import { ResellerApiService } from '@/app/features/reseller';

import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResellerStore {
  private apiService: ResellerApiService = inject(ResellerApiService);

  public sendBecomeResellerRequest(message: string = '') {
    return this.apiService.sendBecomeResellerRequest(message);
  }
}
